module.exports = __webpack_public_path__ + "static/media/carService.57e68e20.png";